import DotsBackground from "../DotsBackground.tsx";
import { QuestionHeader } from "./QuestionHeader.tsx";

const QuestionPageLayout = ({
  children,
  hearts,
  onBack,
  progress,
  darkMode = false,
}) => (
  <div
    className={`min-h-screen p-6 relative ${
      darkMode ? "bg-gray-900" : "bg-gray-100"
    }`}
  >
    <DotsBackground darkMode={darkMode} />
    <div className="max-w-4xl mx-auto relative z-10">
      <QuestionHeader
        hearts={hearts}
        onBack={onBack}
        progress={progress}
        darkMode={darkMode}
      />
      <div className="mt-10">{children}</div>
    </div>
  </div>
);

export default QuestionPageLayout;
